export default {"src":"/_next/static/media/K.b54ae284.svg","height":18,"width":18};